// ============================================================
// HV-TaskFlow V1.1.0 (PWA) — Gắn phiên PWA khi app khởi động.
//
// Làm 2 việc, chỉ khi người dùng ĐÃ đăng nhập:
//   1. Xin phiên dài hạn (refresh token) nếu đang chạy dạng app đã cài.
//      → Không còn bị đá ra đăng nhập lại sau 8 tiếng.
//   2. Đồng bộ lại subscription push.
//      → Cần thiết vì trình duyệt/hệ điều hành có thể tự làm mới endpoint,
//        khi đó bản ghi trong DB đã chết mà người dùng không hề hay biết
//        (biểu hiện: "tự nhiên không nhận được thông báo nữa").
//
// Mọi lỗi ở đây đều NUỐT — không bao giờ được chặn app khởi động.
// ============================================================
import { useEffect } from 'react';
import { useAuthStore } from '@/store/authStore';
import { refreshTokenStore, startDeviceSession } from '@/services/apiClient';
import { isStandalone, resyncPush } from '@/services/pushService';

export function usePwaSession() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) return;

    (async () => {
      try {
        // Chỉ xin phiên dài hạn khi chạy như app đã cài (không áp cho web trên máy tính,
        // để hành vi của web hiện tại giữ nguyên 100%).
        if (isStandalone() && !refreshTokenStore.get()) {
          await startDeviceSession();
        }
      } catch {
        /* bỏ qua */
      }

      try {
        await resyncPush();
      } catch {
        /* bỏ qua */
      }
    })();
  }, [isAuthenticated]);
}
